import InfoIcon from '@mui/icons-material/Info';
import toast from 'react-hot-toast';
import { showAlert } from '../../../store/features/auth/alertSlice';
import { store } from '../../../store/store';
import CommonUtilities from './CommonUtilities';

type NotificationType = 'success' | 'error' | 'info' | 'warning';

export const notifyUser = (
    message: string,
    type: NotificationType = 'success',
    title: string = 'Notification'
): void => {
    const profileDetails = store.getState().profileSettings;
    const notificationStatus = profileDetails.notificationStatus;
    let messageWithTimestamp = message;
    if (type === 'error') {
        const now = new Date();
        const months = CommonUtilities.monthRegularList;
        const month = months[now.getMonth()];
        const day = now.getDate();
        let hours = now.getHours();
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        const formattedTime = `• ${month} ${day}, ${hours}:${minutes} ${ampm}`;
        messageWithTimestamp = `${message} ${formattedTime}`;
    }

    if (notificationStatus === 'Alert' && type !== 'success' && type !== 'info') {
        const newAlertId = Date.now().toString();
        store.dispatch(
            showAlert({
                id: newAlertId,
                status: type,
                message: { [title]: messageWithTimestamp },
            })
        );
    } else {
        // Explicitly handle each type since toast[type] is not safe
        if (type === 'success') {
            toast.success(message);
        } else if (type === 'error') {
            toast.error(messageWithTimestamp);
        } else if (type === 'info') {
            toast(message, {
                icon: (
                    <span style={{ color: '#FFF' }}><InfoIcon /></span>
                ),
                style: { backgroundColor: 'orange', color: '#FFF' },
            });
        } else if (type === 'warning') {
            toast(message, { icon: '⚠️' });
        } else {
            toast(message); // fallback
        }
    }
};
